import isEmpty from 'lodash/isEmpty';

import { LaboratoryOrderData } from 'chaika-frontend-types/frontend-cms';

import { SimpleList } from '@store/models/SimpleList';

export class LaboratoryOrderList extends SimpleList<LaboratoryOrderData> {
    public isAstraLabOrder(id: string): boolean {
        return !isEmpty(this.getExisting(id).laboratoryOrderItems);
    }
}
